import { useQuery } from "@apollo/client";

import { AutocompleteModel } from "~/__generated__";

import { AutocompleteGetOptionsDocument } from "../queries.generated";

export default function useAutocompleteGetOptions({
    model,
    q,
    selectedIds,
    params,
    options,
}: {
    model: AutocompleteModel;
    q?: string;
    selectedIds?: string[];
    params?: object;
    options?: { skip?: boolean };
}) {
    const { data, previousData, loading, error } = useQuery(AutocompleteGetOptionsDocument, {
        variables: {
            model,
            q,
            selectedIds,
            params,
        },
        ...options,
    });

    return {
        loading,
        error,
        data: data?.autocompleteGetOptions,
        selectedData: selectedIds ? (data ?? previousData)?.selectedIds : [],
    };
}
